/**
 * @generated SignedSource<<bef5dbf748c36fefe9cc820763fbe7d2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LandlordCreateAreaPreviewResponseFailure = "ADDRESS_NOT_FOUND" | "%future added value";
export type LandlordCreateAreaPreviewInput = {
  addressId: string;
};
export type useCompareCreateAreaPreviewMutation$variables = {
  input: LandlordCreateAreaPreviewInput;
  turnstileToken: string;
};
export type useCompareCreateAreaPreviewMutation$data = {
  readonly landlordCreateAreaPreview: {
    readonly failures: ReadonlyArray<LandlordCreateAreaPreviewResponseFailure> | null | undefined;
    readonly preview: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type useCompareCreateAreaPreviewMutation = {
  response: useCompareCreateAreaPreviewMutation$data;
  variables: useCompareCreateAreaPreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "turnstileToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "turnstileToken",
        "variableName": "turnstileToken"
      }
    ],
    "concreteType": "LandlordCreateAreaPreviewResponse",
    "kind": "LinkedField",
    "name": "landlordCreateAreaPreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LandlordAreaPreview",
        "kind": "LinkedField",
        "name": "preview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failures",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompareCreateAreaPreviewMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCompareCreateAreaPreviewMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "796ae2767f6460f72720d2da607d74f8",
    "id": null,
    "metadata": {},
    "name": "useCompareCreateAreaPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation useCompareCreateAreaPreviewMutation(\n  $input: LandlordCreateAreaPreviewInput!\n  $turnstileToken: String!\n) {\n  landlordCreateAreaPreview(input: $input, turnstileToken: $turnstileToken) {\n    preview {\n      id\n    }\n    failures\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0f62fa7f6bacba6bde7e34fae428a57";

export default node;
